import { useQuery } from '@tanstack/react-query';
import { CourseService } from '@/services';

export function useFlashcardDecksAndStats(courseId?: string) {
  return useQuery({
    queryKey: ['flashcardDecksAndStats', courseId],
    queryFn: () => CourseService.getFlashcardDecksAndStats(courseId ?? ''),
    enabled: !!courseId,
    refetchOnMount: 'always',
  });
}

// Do not use the stats response directly -> Only be used to update flashcardDecksAndStats state
export function useFlashcardAndStats(courseId?: string, deckId?: string) {
  return useQuery({
    queryKey: ['flashcardAndStats', courseId, deckId],
    queryFn: () => CourseService.getFlashcardAndDeckStats(courseId ?? '', deckId ?? ''),
    enabled: !!courseId && !!deckId,
  });
}
